import { useSearchParams, useNavigate } from 'react-router-dom'
import { UserCircleIcon, PlusIcon } from '@heroicons/react/solid'
import { savedTokens, useAuth } from 'src/auth'
import {
  Anchor,
  Aside,
  Main,
  Paragraph,
  StickyFooter,
  Subtitle,
} from 'src/components'
import Logging from '../Logging'
import {
  savedAppClientId,
  savedRegToken,
  savedUserPoolId,
  savedUserPoolRegion,
} from '../Onboarding/storage'
import { getEnvString } from 'src/utils'
import EmailHelpBox from 'src/components/Layout/EmailHelpBox'
import LoggedInNavigate from './LoggedInNavigate'
import CustomButton from 'src/components/Shared/UIComponents/Button'

export default function Marketplace() {
  const navigate = useNavigate()
  const { login, isLoading } = useAuth()
  const [tokens] = savedTokens.useState(null)
  const [searchParams] = useSearchParams()

  const regToken = searchParams.get('regtoken')
  const userPoolRegion = searchParams.get('setupuserPoolRegion')
  const userPoolId = searchParams.get('setupuserPoolId')
  const appClientId = searchParams.get('setupuserPoolAppClientId')

  const disabled = !regToken || !userPoolRegion || !userPoolId || !appClientId

  return (
    <>
      <Logging />

      <Aside title="Provisioning" hideExtraRow disableLogin displayHelp />
      <Main>
        <div className="grid grid-cols-2 gap-8">
          <Subtitle label="New Organization" />
          <Subtitle label="Existing organization" />

          <Paragraph>
            If you're new and have never used Mobile Connect before, please
            select this option
          </Paragraph>
          <Paragraph>
            If you have used Mobile Connect before, please Login
          </Paragraph>

          <div>
            <CustomButton
              label="Create organization"
              type="button"
              disabled={disabled}
              onClick={() => {
                if (disabled) return
                savedRegToken.set(regToken)
                savedUserPoolRegion.set(userPoolRegion)
                savedUserPoolId.set(userPoolId)
                savedAppClientId.set(appClientId)
                navigate('/onboarding/details')
              }}
              icon={<PlusIcon />}
              iconPosition="left"
            />
            {disabled && (
              <div className="text-xs text-slate-400 mt-2">
                To create a new organization you need to come from the
                <Anchor
                  href={getEnvString('REACT_APP_MARKETPLACE')}
                  className="ml-2"
                  target="_blank"
                >
                  Amazon Marketplace
                </Anchor>
              </div>
            )}
          </div>
          <div>
            <CustomButton
              onClick={login}
              label="Login"
              loadingLabel="Logging in"
              isLoading={isLoading}
              icon={<UserCircleIcon />}
              iconPosition="left"
            />
          </div>
        </div>
        {tokens && (
          <LoggedInNavigate
            username={tokens.username}
            organization={tokens.organization}
          />
        )}
        <div className="mt-10" />
        <StickyFooter>
          <EmailHelpBox className="flex-1" />
        </StickyFooter>
      </Main>
    </>
  )
}
